"use strict";

import Vue from 'vue'
import VueFilterNumber from '@/vue/filters/vue-filter-number'
import allBetMixin from '@/vue/mixins/allBet'
import minibet from '@/vue/components/mini-bet'

import EventBus from '@/vue/events/event-bus'

import {
  mapGetters,
} from 'vuex'

Vue.component('odd', {
  components: {
    minibet,
  },
  mixins: [allBetMixin],
  name: 'odd',
  template: ` 
    <div :id="getOddUniqueId(event)" class="odds" :class="[getOdCls(mode,betType,event), getClass(event, isNegative, isDiff, isUp, isClosePause)]" @click="onClickOdd($event);" >
    <div  v-if="mode=='ab' && checkTitleBt()" :style="(betType == '8' || betType == '1')? 'padding:17px 50%;':'padding:17px 43%;'" :title="getTitle()"></div>
      <template v-if="event.od">
        <template v-if="event.od[plyType]">
          <template v-if="event.od[plyType][betType]">
            <template v-if="event.od[plyType][betType][matchId]">
              <template v-if="oddValidation(event)">
                <template v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))">
                  <span>{{ getDecimalDisplay(betForm.odd) }}</span>
                </template>
                <template v-else>
                  <template v-if="mode=='ab'">
                    <div class="">
                      <span class="yb-family-odds yb-number-bold match_details"> <!-- up/down : odds updown-->
                      {{ getDecimalDisplay(event.od[plyType][betType][matchId][team]) }}
                      </span>
                    </div>
                  </template>
                  <template v-else>
                    <span>
                      {{ getDecimalDisplay(event.od[plyType][betType][matchId][team]) }}
                    </span>
                  </template>
                </template>
                
                <div class="odds-arrows-wrap" v-if="mode!='ab'">
                  <div class="odds-icon odds-up"></div>
                  <div class="odds-icon odds-down"></div>
                </div>
              </template>
              <template v-else>
                <div class="lock m-icon"></div>
              </template>
            </template>
            <template v-else>
              <div class="lock m-icon" style="margin: auto;"></div>
            </template>
          </template>
          <template v-else>
            <div class="lock m-icon" style="margin: auto;"></div>
          </template>
        </template>
        <template v-else>
          <div class="lock m-icon" style="margin: auto;"></div>
        </template>
      </template>
      <template v-else>
        <div class="lock m-icon" style="margin: auto;"></div>
      </template> 
    </div>
  `,
  // <div>
  //     <template v-if="event.od">
  //       <template v-if="event.od[plyType]">
  //         <template v-if="event.od[plyType][betType]">
  //           <template v-if="event.od[plyType][betType][matchId]">
  //             <template v-if="oddValidation(event)">
  //               <div class="oddsBet" :class="getClass(event, isNegative, isDiff, isUp)" @click="onClickOdd($event);">
  //                 <span :class="[getOddUniqueClass(event), {ngve: isNegative, diff: isDiff}]">
  //                   <template v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))">
  //                     {{ getDecimalDisplay(betForm.odd) }}
  //                   </template>
  //                   <template v-else>
  //                     {{ getDecimalDisplay(event.od[plyType][betType][matchId][team]) }}
  //                   </template>
  //                 </span>
  //                 <minibet v-if="sportMiniBet.allow && sportMiniBet.toggle && checkMiniBetUnique(event, getOddUniqueId(event))"></minibet>
  //               </div>
  //             </template>
  //           </template>
  //         </template>
  //       </template>
  //     </template>    
  // </div>

  props: {
    event: null,
    team: null,
    plyType: null,
    teamaname: null,
    teambname: null,
    betType: null,
    match: null,
    lang: null,
    mode: null, //ab = allbet
    wdth: null,
  },
  computed: {
    ...mapGetters([
      'sportMiniBet',
      'changeOdds',
      'isChangeTemplate',
      'isParlayTab',
      'specialEvent',
    ]),
    betForm() {
      return this.$store.getters.betForm[0]
    },
  },
  watch: {
    'event': {
      handler(val, oldVal) {
        //cater for 3 match only
        if (this.match == 0 || this.match == 'a')
          this.matchId = 'a'
        else if (this.match == 1 || this.match == 'b')
          this.matchId = 'b'
        else if (this.match == 2 || this.match == 'c')
          this.matchId = 'c'
        else
          this.matchId = 'd'
        if (this.isDefinedOdds(val)) {
          this.classNegative(val.od[this.plyType][this.betType][this.matchId][this.team])
          if (oldVal && !this.isChangeTemplate) {
            this.refreshOdd = false
            if (this.isDefinedOdds(oldVal)) {
              this.diffOddsUpDown(val.od[this.plyType][this.betType][this.matchId][this.team], oldVal.od[this.plyType][this.betType][this.matchId][this.team])
              this.diffOdds(val.od[this.plyType][this.betType][this.matchId][this.team], oldVal.od[this.plyType][this.betType][this.matchId][this.team])
            }
          } else if (this.refreshOdd) {
            this.refreshOdd = false
            this.isDiff = false
          } else if (!oldVal) { //when not same template
            this.refreshOdd = true
          }
        } else {
          this.isClosePause = true
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isNegative: false,
      isDiff: false,
      isUp: false,
      isClosePause: false,
      matchId: null,
      refreshOdd: false,
    }
  },
  methods: {
    getOdCls(mode, bt, event) {
      var a = ' odds-default'
      if (mode == 'ab') {
        a += ' yb-number-font'
        if (jQuery.inArray(bt, ['1', '8',]) != '-1') {
          a += ' odds-hdp ' + a
        } else if (bt == '2') {
          a += ' odds-ou ' + a
        }
        if(jQuery.inArray(bt, ['1', '3', '8', '10', '59', '60', '61', '62', '63', '64', '73']) == '-1'){
          a += ' c-center'
        } else {
          a += ' c-right'
        }
      } else {
        a += ' c-right'
      }
      // style="position: absolute;inset: 0px;"  :style="{'margin-right':event.sptid==1 ? '10px':'15px' , 
      // 'justify-content': mode=='ab'&& betType!=1 && betType!=3 && betType!=8 ? 'center': 'right'}" 
      return a
    },
    getClass(event, isNeg, isDif, isUp, isClosePause) {
      var classStr = ''
      var classMini = ''

      // if (this.sportMiniBet.allow && this.sportMiniBet.toggle && this.checkMiniBetUnique(event, this.getOddUniqueId(event))) {
      //   classMini = ' selected panelActive'
      //   if (this.sportMiniBet.rightside) {
      //     classMini = ' selected panelActive-bottomRight'
      //   }

      //   if (this.betForm.oddChg) {
      //     classStr = 'indicator'
      //   }
      // }

      if (this.changeOdds && false) {
        if (!this.refreshOdd && isDif) {  //change odds
          classStr = 'indicator'
        }
      } else if (isClosePause) {
        classStr = ''
      } else {
        if (!this.isChangeTemplate && isDif) {  //refresh
          if (isUp) {
            classStr = 'up'
            // classStr = 'indicatorUp'
            // $('div').closest('.odds.indicator').closest('.c-bet-item').addClass('up')
          } else {
            classStr = 'down'
            // classStr = 'indicatorDown'
            // $('div').closest('.odds.indicator').closest('.c-bet-item').addClass('down')
          }
        }
      }

      return classStr + classMini
    },
    checkTitleBt() {
      if(['1','8','62','63','64'].includes(this.betType.toString())) {
        return true
      } 
      return false
    },
    getTitle(){
      const parser = new DOMParser();
      // hdp
      if(this.betType == '8' || this.betType == '1') {
        return (this.team=='oddsb')?parser.parseFromString(this.event.tbcapt, "text/html").body.textContent:parser.parseFromString(this.event.tacapt, "text/html").body.textContent 
      }

      // 1x2 & ou
      if(this.betType == '63' || this.betType == '64') {
        if(this.team == 'oddsha') { 
          return this.event.tacapt +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER']
        } else if (this.team == 'oddshb') {
          return this.event.tacapt +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER']
        } else if (this.team == 'oddsda') { 
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER']
        } else if (this.team == 'oddsdb') { 
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER']
        } else if (this.team == 'oddsaa') { 
          return this.event.tbcapt +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER']
        } else { 
          return this.event.tbcapt +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER']
        }
      }

      // 62 ou & fts 
      if(this.betType == this.ouftsBetType) {
        if(this.team == 'oddsha') { 
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + this.event.od[this.plyType][this.ouftsBetType][this.matchId]['hdp'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt
        } else if (this.team == 'oddshb') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + this.event.od[this.plyType][this.ouftsBetType][this.matchId]['hdp'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt
        } else if (this.team == 'oddsaa') { 
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + this.event.od[this.plyType][this.ouftsBetType][this.matchId]['hdp'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt
        } else { 
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + this.event.od[this.plyType][this.ouftsBetType][this.matchId]['hdp'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt
        }
      }
    },
    getOddUniqueClass(event) {
      var classStr = ''
      if (this.plyType == '2') {
        classStr += 'ht '
      }
      classStr += this.getOddUniqueId(event)
      return classStr
    },
    getOddUniqueId(event) {
      return event.eveid + this.plyType + this.betType + this.matchId + this.team
    },
    oddValidation(event) {
      var param = {}
      param.odds = parseFloat(event.od[this.plyType][this.betType][this.matchId][this.team])
      param.hdp = event.od[this.plyType][this.betType][this.matchId]['hdp']
      param.bettype = parseInt(this.betType)
      param.oddstype = (this.$store.getters.selectedBettype.betTypId == 5 && this.isParlayTab && this.$store.getters.account.oddsType != 'am') ? this.$store.getters.oddTypesList.EU.key : this.$store.getters.account.oddstype
      if(event.sptid == 255) {
        param.oddstype = (this.betType == 12)? this.$store.getters.oddTypesList.EU.key : this.$store.getters.oddTypesList.HK.key
      }
      return this.validateOddHdp(param)
    },
    onClickOdd(windowEvent = null) {
      EventBus.$emit('returnBetTab')
      if (this.account.previewFlag && window._hasRedirect) {
        $('.login-redirect-dialog').show();
        return
      }
      if(this.event.od[this.plyType][this.betType] == undefined || ((this.$store.getters.account.oddsType != 'in' && this.$store.getters.account.oddsType != 'my' && this.$store.getters.account.oddsType != 'am') && this.event.od[this.plyType][this.betType][this.matchId][this.team]<=0)){
        return
      }
      if(!this.oddValidation(this.event)) {
        return
      }
      if (!this.account.previewFlag) {
        var teamBet = this.team[this.team.length - 1];
        var betForm = {
          title: this.$store.getters.selectedBettype.sprtTitleLang,
          league: this.event.lgecapt,
          sprtid: this.event.sptid,
          eveid: this.event.eveid,
          plyType: this.plyType,
          ta: this.event.tacapt,
          tb: this.event.tbcapt,
          taid: this.event.taid,
          tbid: this.event.tbid,
          betType: this.betType,
          tbetcapt: this.event['t' + teamBet + 'capt'],
          tbetid: this.event['t' + teamBet + 'id'],
          rbscoa: 0,
          rbscob: 0,
          dual: this.matchId,
          fav: '0',
          ha: this.event.ha,
          odd: this.event.od[this.plyType][this.betType][this.matchId][this.team],
          uniqueId: this.event.eveid + this.plyType + this.betType + this.matchId + this.team,
          //hdp: this.event.od[this.plyType][this.betType][this.matchId].hdp,
          eventObj: this.event,
        }

        if (this.event.rb) {
          if (this.event.rbinfo) {
            betForm.rbscoa = this.event.rbinfo.scoa
            betForm.rbscob = this.event.rbinfo.scob
          }
        }

        var hdp = this.event.od[this.plyType][this.betType][this.matchId]['hdp'].split('/', 2)
        if (hdp.length > 1) {
          var hdp0 = parseFloat(hdp[0])
          var hdp1 = parseFloat(hdp[1])
          betForm.hdp = (hdp0 + hdp1) / 2
        } else {
          var hdp0 = parseFloat(hdp[0])
          betForm.hdp = hdp0
        }
        //TODO switch case for bettype to return bet form data, shared based with odds1x2
        var fav = this.event.od[this.plyType][this.betType][this.matchId].fav
        switch (this.betType.toString()) {
          case this.hdpBetType:
          case this.rhdpBetType:
            betForm.tbet = teamBet == 'a' ? 'a' : 'b'
            betForm.hdp = (teamBet == 'a' && fav == 'a') || (teamBet == 'b' && fav == 'b') ? betForm.hdp * -1 : betForm.hdp
            betForm.fav = fav
            betForm.colorDis = 0
            if (this.event.od[1] && this.event.od[1][this.betType] && this.event.od[1][this.betType]['a'] && this.event.od[1][this.betType]['a'].hdp != 0 && this.event.od[1][this.betType]['a'].fav == teamBet) {
              betForm.colorDis = 1
            } else if (this.event.od[3] && this.event.od[3][this.betType] && this.event.od[3][this.betType]['a'] && this.event.od[3][this.betType]['a'].hdp != 0 && this.event.od[3][this.betType]['a'].fav == teamBet) {
              betForm.colorDis = 1
            }
            break;
          case this.ouBetType:
          case this.rouBetType:
          case this.htgBetType:
          case this.rhtgBetType:
          case this.atgBetType:
          case this.ratgBetType:
          case this.htrBetType:
          case this.rhtrBetType:
          case this.atrBetType:
          case this.ratrBetType:
            betForm.tbet = teamBet == 'a' ? 'a' : 'b'
            var capt = betForm.tbet == 'a'
              ? 'ALL_BET.LBL_OVER'
              : 'ALL_BET.LBL_UNDER'
            betForm.tbetcapt = this.$store.getters.sportAllBetLang[capt] + ' ' + betForm.hdp
            betForm.fav = fav
            break;
          case this.oeBetType:
          case this.roeBetType:
            betForm.tbet = teamBet == 'a' ? 'a' : 'b'
            var capt = betForm.tbet == 'a'
              ? 'ALL_BET.LBL_ODD'
              : 'ALL_BET.LBL_EVEN'
            betForm.tbetcapt = this.$store.getters.sportAllBetLang[capt]
            betForm.fav = fav
            break;
          case this.bttsBetType:
          case this.rbttsBetType:
            betForm.tbet = teamBet == 'a' ? 'a' : 'b'
            var capt = betForm.tbet == 'a'
              ? 'ALL_BET.LBL_YES'
              : 'ALL_BET.LBL_NO'
            betForm.tbetcapt = this.$store.getters.sportAllBetLang[capt]
            betForm.fav = fav
            break;
          case this.onex2ouBetType:
          case this.ronex2ouBetType:
            if(this.team == 'oddsha') { 
              betForm.tbetcapt = this.event.tacapt +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER']
              betForm.tbetid = 'ha'
              betForm.tbet = 'ha'
              teamBet = 'ha'
            } else if (this.team == 'oddshb') {
              betForm.tbetcapt = this.event.tacapt +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER']
              betForm.tbetid = 'hb'
              betForm.tbet = 'hb'
              teamBet = 'hb'
            } else if (this.team == 'oddsda') { 
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER']
              betForm.tbetid = 'da'
              betForm.tbet = 'da'
              teamBet = 'da'
            } else if (this.team == 'oddsdb') { 
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER']
              betForm.tbetid = 'db'
              betForm.tbet = 'db'
              teamBet = 'db'
            } else if (this.team == 'oddsaa') { 
              betForm.tbetcapt = this.event.tbcapt +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER']
              betForm.tbetid = 'aa'
              betForm.tbet = 'aa'
              teamBet = 'aa'
            } else { 
              betForm.tbetcapt = this.event.tbcapt +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER']
              betForm.tbetid = 'ab'
              betForm.tbet = 'ab'
              teamBet = 'ab'
            }
            break;
          case this.ouoeBetType:
          case this.rouoeBetType:
            if(this.team == 'oddsha') { 
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + this.event.od[this.plyType][this.betType][this.matchId]['hdp'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_ODD']
              betForm.tbetid = 'ha'
              betForm.tbet = 'ha'
              teamBet = 'ha'
            } else if (this.team == 'oddshb') {
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + this.event.od[this.plyType][this.betType][this.matchId]['hdp'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_EVEN']
              betForm.tbetid = 'hb'
              betForm.tbet = 'hb'
              teamBet = 'hb'
            } else if (this.team == 'oddsaa') { 
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + this.event.od[this.plyType][this.betType][this.matchId]['hdp'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_ODD']
              betForm.tbetid = 'aa'
              betForm.tbet = 'aa'
              teamBet = 'aa'
            } else { 
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + this.event.od[this.plyType][this.betType][this.matchId]['hdp'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_EVEN']
              betForm.tbetid = 'ab'
              betForm.tbet = 'ab'
              teamBet = 'ab'
            }
            break;
          case this.oubttsBetType:
          case this.roubttsBetType:
            if(this.team == 'oddsha') { 
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']
              betForm.tbetid = 'ha'
              betForm.tbet = 'ha'
              teamBet = 'ha'
            } else if (this.team == 'oddshb') {
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']
              betForm.tbetid = 'hb'
              betForm.tbet = 'hb'
              teamBet = 'hb'
            } else if (this.team == 'oddsaa') { 
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']
              betForm.tbetid = 'aa'
              betForm.tbet = 'aa'
              teamBet = 'aa'
            } else { 
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']
              betForm.tbetid = 'ab'
              betForm.tbet = 'ab'
              teamBet = 'ab'
            }
            break;
          case this.ouftsBetType:
            if(this.team == 'oddsha') { 
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + this.event.od[this.plyType][this.ouftsBetType][this.matchId]['hdp'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt
              betForm.tbetid = 'ha'
              betForm.tbet = 'ha'
              teamBet = 'ha'
            } else if (this.team == 'oddshb') {
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + this.event.od[this.plyType][this.ouftsBetType][this.matchId]['hdp'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt
              betForm.tbetid = 'hb'
              betForm.tbet = 'hb'
              teamBet = 'hb'
            } else if (this.team == 'oddsaa') { 
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + this.event.od[this.plyType][this.ouftsBetType][this.matchId]['hdp'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tacapt
              betForm.tbetid = 'aa'
              betForm.tbet = 'aa'
              teamBet = 'aa'
            } else { 
              betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + this.event.od[this.plyType][this.ouftsBetType][this.matchId]['hdp'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] + ' ' + this.event.tbcapt
              betForm.tbetid = 'ab'
              betForm.tbet = 'ab'
              teamBet = 'ab'
            }
            break;
          case this.mlBetType:
            if(this.specialEvent) { 
              betForm.tbet = teamBet == 'a' ? 'a' : 'b'
            }
            break;
          default:
          //NOTHING
        }

        if (this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key) {
          var market = this.$store.getters.market.inPlayMarket
          betForm.plytypcapt = '(' + market.betLang + ') ' + this.plyType
        } else if (this.$store.getters.selectedMarket == this.$store.getters.market.earlyMarket.key) {
          //     betForm.title = this.$store.getters.selectedBettype.sprtTitleLang + ' - ' + this.$store.getters.market.earlyMarket.betLang
        }
        
        // Check if current sel has selected, if true remove else add
        var indexx = _.findIndex(this.$store.getters.betForm, {
          'eveid': this.event.eveid,
          'plyType': this.plyType,
          'betType': this.betType,
          'dual': this.matchId,
          'tbet': teamBet,
        });

        if(indexx > -1){
          var obj = {eveid: this.event.eveid}
          if(this.$store.getters.isBetCombo){
            obj = {clearType: '3', index: indexx}
          }
          this.$store.commit("BETCOMBO_AMOUNT", { spliceIndex: true, index: indexx });
          this.$store.commit("BETCOMBO_KEYBOARDALLOW", { spliceIndex: true, index: indexx });

          this.$store.dispatch("removeMatch", {
            // eveid: this.event.eveid,
            data: obj,
            callback: (() => {
              this.$store.commit("PARLAY_SELECTED", {
                remove: true,
                eveid: this.event.eveid,
              });
              var MID = $(windowEvent.target).closest('div[id]')[0].id
              // document.getElementById(MID).parentElement.classList.remove('active')
              $("[id="+MID+"]").closest('.c-bet-item.active').removeClass('active')

              if (this.$store.getters.betForm.length <= 0) {
                this.$store.commit("OPEN_BETFORM", false)
                this.$store.commit('ODD_SELECTED', false)
                this.$store.commit("SHOW_BETFORM_MENU", false);
                this.$store.commit('SELECTED_TAB', 'betTab')
                return;
              } else {
                this.$store.commit('OPEN_BETFORM', true)
              }
              this.$store.dispatch("getBettingInfo", {
                callback: ((res) => {
                  this.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: this.$store.getters.betForm,
                  });
                }).bind(this),
              });
            }).bind(this),
          });
        } else {
          //betcombo validate max betcombo wager
          if(this.$store.getters.isBetCombo && this.$store.getters.betForm.length==this.betComboMax){
            var chkRes = this.checkBetComboMax(betForm)
            if(chkRes){
              return
            }
          }
          // parlay
          if(this.$store.getters.selectedBettype.betTypId == '5' && this.$store.getters.betting.minMax!=undefined && this.$store.getters.betting.minMax.maxCombo!=undefined){
            if(this.$store.getters.betForm.length==this.$store.getters.betting.minMax.maxCombo){
              let vue = this
              let maxMulpComboMsg = this.$store.getters.betLang['BETTING.HIT_MAX_COMBO']
              this.$store.commit('DIALOG_TOGGLE',{
                show: true,
                msg: maxMulpComboMsg
              })
              // this.$store.commit('JS_ERR', {error:true, msg:maxMulpComboMsg})
              setTimeout(function() {
                // vue.$store.commit('JS_ERR', {error:false})
                vue.$store.commit('DIALOG_TOGGLE', {reset:true})
              }, 5000);
              return
            }
          }

          this.$store.dispatch('getLatestInfo', {
            data: betForm,
            callback: ((res) => {
              this.$store.commit('CLEAR_BET_SUCCESS')
              this.$store.commit('OPEN_BETFORM', true)
              this.oddSelectHighlight(windowEvent, betForm)

              if (res.SYSTEM_DATA.status != 'FAIL') {
                if(this.$store.getters.miniNormal==1){
                  this.showMiniBet(windowEvent);
                  if(this.$store.getters.sportMiniBet.toggle){
                    EventBus.$emit('expandMini')
                  }
                }
                if(!this.$store.getters.isBetCombo){  //single 
                  this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0)
                  EventBus.$emit('resetKeyboard')
                }

                this.$store.commit('ODD_SELECTED', true)
                // this.$store.commit('SELECTED_BETTAB', true)
                this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm
                })
                //multisingle & > 1 wager
                if(this.$store.getters.isBetCombo && this.$store.getters.betForm.length>1){ 
                  EventBus.$emit('clearAllBetComboAmount');
                  EventBus.$emit('resetKeyboard')
                }
                if (windowEvent) {
                  this.$store.commit('PARLAY_SELECTED', {
                    class: $(windowEvent.target).parents('.b_rig'),
                    eveid: this.event.eveid
                  })
                }
              } else if (res.SYSTEM_DATA.status == 'FAIL') {
                // } else if (res.SYSTEM_DATA.status == 'FAIL' && res.SYSTEM_DATA.code == 'S-4-S') {
                if(this.$store.getters.miniNormal==1){
                  this.showMiniBet(windowEvent);
                }
                
                if(!this.$store.getters.isBetCombo){
                  this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0)
                }
                this.$store.commit('ODD_SELECTED', true)
                // this.$store.commit('SELECTED_BETTAB', true)
                this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm
                })
                if (windowEvent) {
                  this.$store.commit('PARLAY_SELECTED', {
                    class: $(windowEvent.target).parents('.b_rig'),
                    eveid: this.event.eveid
                  })
                }
              }
            }).bind(this)
          })
        }
        
      }
    },
    classNegative(val, oldVal) {
      this.isNegative = val < 0 ? true : false
    },
    diffOdds(val, oldVal) {
      this.isDiff = val != oldVal ? true : false
    },
    diffOddsUpDown(val, oldVal) {
      this.isUp = parseFloat(val) > parseFloat(oldVal) ? true : false
    },
    isDefinedOdds(val) {
      var isDefinedOdds = false
      if (typeof val.od != 'undefined') {
        if (typeof val.od[this.plyType] != 'undefined') {
          if (typeof val.od[this.plyType][this.betType] != 'undefined') {
            if (typeof val.od[this.plyType][this.betType][this.matchId] != 'undefined') {
              isDefinedOdds = true
            }
          }
        }
      }
      return isDefinedOdds
    },
  },
  beforeMount() {
    EventBus.$on(['refreshOdd'], ((params) => {
      if (params == false) {
        this.refreshOdd = false // change market, change page, change parlayEarlyDate
      } else {
        this.refreshOdd = true // change odd type, refresh button
      }
    }).bind(this))

    EventBus.$on(['diffOdd'], ((params) => {
      if (typeof this.event.all == 'undefined') {
        if (this.isDefinedOdds(this.event) && this.isDefinedOdds(params)) {
          //if is special league odds
          if (params.sp) {
            var eveid = this.event.eveid
            //if is special league odds and same eveid
            if (params.sp[eveid]) {
              if (this.isDefinedOdds(this.event) && this.isDefinedOdds(params.sp[eveid])) {
                this.diffOddsUpDown(params.sp[eveid].od[this.plyType][this.betType][this.matchId][this.team], this.event.od[this.plyType][this.betType][this.matchId][this.team])
                this.diffOdds(params.sp[eveid].od[this.plyType][this.betType][this.matchId][this.team], this.event.od[this.plyType][this.betType][this.matchId][this.team])
              }
            } else {
              this.diffOddsUpDown(params.od[this.plyType][this.betType][this.matchId][this.team], this.event.od[this.plyType][this.betType][this.matchId][this.team])
              this.diffOdds(params.od[this.plyType][this.betType][this.matchId][this.team], this.event.od[this.plyType][this.betType][this.matchId][this.team])
            }
          } else {
            this.diffOddsUpDown(params.od[this.plyType][this.betType][this.matchId][this.team], this.event.od[this.plyType][this.betType][this.matchId][this.team])
            this.diffOdds(params.od[this.plyType][this.betType][this.matchId][this.team], this.event.od[this.plyType][this.betType][this.matchId][this.team])
          }
          this.$forceUpdate()
        }
      }
    }).bind(this))
  },

  mounted() {
    this.$store.getters.betForm.forEach(value => {
      var MID = value.uniqueId;
      $("[id="+MID+"]").closest('.c-bet-item').addClass('active')
    })
  }

})



// WEBPACK FOOTER //
// ./resources/wob/vue/components/odd.js